import { useState, useEffect } from 'react';
import UnivReqComp from '../UnivReqComp';
import useAuth from '../../../../features/hooks/useAuth';


export default function SentTable({ subTabValue, handleEditclick }) {
  const Auth = useAuth();
  const [limit, setLimit] = useState(5);
  const [lastId, setLastId] = useState(null);
  const [filterProps, setFilterProps] = useState({});  

  useEffect(() => {
    if (!Auth?.id) return;
  
    let updatedFilterProps = {};
    let sent_to_tag_filter = [];
  
    switch (subTabValue) {
      case 0:
        // User Sentbox
        sent_to_tag_filter = [
          "ureq_created",
          "ureq_resubmit_modified",
          "user_resubmit_return",
          "ureq_rtrn_asst_created",
          "ureq_paraccept_fwdstore",
          "ureq_retrn_ind_store_created"
        ];
        break;
      case 1:
        // BO Sentbox
        sent_to_tag_filter = [
          "boreq_fwd_unithead",
          "boreq_back_user_mod",
          "boreq_issueallclose_forapprv",
          "boreq_parissue_forapprv",
          "boreq_parissueclse_forapprv",
          "bo_return_to_user_mod",
          "bo_store_return_created",
          "bo_forwarded_to_store",          
        ];
        break;
      case 2:
        // Unit Head Sentbox
        sent_to_tag_filter = [
          "uhreq_bolvl_rtrned_mod",
          "uhreq_fwded_store",
          "uhreq_paraprvd_forstore",
          "uhreq_paraprvd_forclose",
          "uhreq_allbolvlaprvd_forclose",
          "new_bo_transfer_req",
          "unithead_forwarded_to_store",
          "unithead_return_to_bo"
        ];
        break;
      case 3:
        // Asset Manager Sentbox
        sent_to_tag_filter = [
          "ureq_storeassetsaccpt_close",
          "ureq_assets_rejected",
          "ureq_allasstbolvl_close",
          "ureq_paraccept_close",
          "ureq_paraccept_fwdstore",
          "store_return_approved",
          "lvl2req_apprvd_foraccptnce",
          "lvl1req_fwd_selected_assets",
          "lvl2req_back_formodific"
        ];
        break;
      case 6:
        // All Requests - no specific tags, show all requests for the store
        sent_to_tag_filter = [];
        break;
      default:
    }
  
    // Filter for outbox - show items where current user sent items with specific tags
    if (subTabValue === 6) {
      // All Requests - show all requests for the current user's store only
      updatedFilterProps = {
        perm_req_store: Auth.store ? [Auth.store] : []
      };
    } else {
      // Regular filtering for other sub tabs
      updatedFilterProps = {
        req_data_sent_to_tags: { id:Auth.id, tags:sent_to_tag_filter },
        perm_flow_users: [Auth.id]
      };
    }

    if (subTabValue !== 5) {
      updatedFilterProps.perm_curr_status = ["Pending"]
    } else {
      updatedFilterProps.perm_curr_status = ["Rejected", "Closed", "Terminated"]
    }
  
    setFilterProps(prevProps => {
      return JSON.stringify(prevProps) !== JSON.stringify(updatedFilterProps) ? updatedFilterProps : prevProps;
    });
    
  }, [Auth?.id, subTabValue]);

  const columnFilter = [
    "UniqueReqId", "Req_Type", "Req_Creator", "Store", "Curr_Status", "Created_At",
    "Currently_With", "Status", "Action"
  ];
console.log(filterProps)
  return (
    <>
      <UnivReqComp
        filterProps={filterProps}  
        columnFilter={columnFilter}
        handleEditclick={handleEditclick}
        limit={limit} 
        setLimit={setLimit} 
        lastId={lastId} 
        setLastId={setLastId} 
        viewType="sentbox"
      />    
    </>
  );
}